import React from 'react'

const DuLieuMonAnContext = React.createContext(({
    dishId: null, 
    imageId: null, 
    conceptId: null, 
})); 

export default DuLieuMonAnContext; 